import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { Alert, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Sponsors from '../store/Sponsors';
import * as utility from '../data/Utility';

const createSponsorType = {
    code: "code",
    name: "name"
}

class CreateSponsorInternal extends React.Component {
    constructor(props) {
        super(props);

        const create = utility.propCheck(props.create, true);
        const editing = utility.propCheck(props.editing, true);
        const sponsorId = utility.propCheck(props.sponsorId, "");
        this.state = {
            create: create,
            editing: editing,
            error: false,
            sponsorId: sponsorId
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleValue = this.handleValue.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize();
    }

    handleCancel() {
        if (this.state.create) {
            this.props.history.push(paths.home);
        }
        else {
            this.initialize();
            if (this.state.editing) {
                this.setState({
                    editing: false
                });
            }
        }
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleClick();
        }
    }

    handleSave() {
        const sponsor = this.props.sponsorsState.sponsor;
        if (sponsor.name === "") {
            this.setState({
                error: true
            });
        }
        else {
            this.setState({
                error: false
            });

            if (this.state.create) {
                this.props.sponsorsDispatch.create();
                this.props.history.push(paths.home);
            }
            else {
                (async () => {
                    await this.props.sponsorsDispatch.update();
                })().then(() => {
                    this.props.history.push(paths.manageSponsors);
                });
            }
        }
    }

    handleValue(type, value) {
        const sponsor = this.props.sponsorsState.sponsor;
        switch (type) {
            case createSponsorType.code:
                sponsor.code = value;
                break;
            case createSponsorType.name:
                sponsor.name = value;
                break;
            default:
                break;
        }
        this.props.sponsorsDispatch.set(sponsor);
    }

    initialize() {
        if (this.state.create) {
            const sponsor = JSON.parse(JSON.stringify(Sponsors.emptySponsor));
            this.props.sponsorsDispatch.set(sponsor);
        }
        else {
            this.props.sponsorsDispatch.get(this.state.sponsorId);
        }
    }

    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const cancel = "Cancel";
        var code = "";
        var displayEditLink = false;
        const editing = this.state.editing;
        var name = "";
        const optional = " - Optional";
        const save = "Save";
        const sponsor = this.props.sponsorsState.sponsor;
        var title = "Create Sponsor";

        if (!this.state.create) {
            if (editing) {
                title = "Edit Sponsor";
            }
            else {
                displayEditLink = true;
                title = "Sponsor";
            }
        }

        if (sponsor != null) {
            if (sponsor.code != null) {
                code = sponsor.code;
            }
            if (sponsor.name != null) {
                name = sponsor.name;
            }
        }

        return (
            <Form>
                <h1>{title} {displayEditLink && <Button className="button-link" onClick={() => this.setState({ editing: true })}>(Edit)</Button>}</h1>
                {this.state.error && <Alert color="warning">Missing or incorrect fields.</Alert>}
                <FormGroup>
                    <Label for="nameInput">Name</Label>
                    <Input className="input" disabled={!editing} id="nameInput" onChange={(e) => this.handleValue(createSponsorType.name, e.target.value)} onKeyDown={this.handleKeyDown} type="text" value={name} />
                </FormGroup>
                <div>
                    <Label for="codeInput">Code<i><small>{optional}</small></i></Label>
                    <Input className="input" disabled={!editing} id="codeInput" onChange={(e) => this.handleValue(createSponsorType.code, e.target.value)} onKeyDown={this.handleKeyDown} type="text" value={code} />
                </div>
                {editing && (
                    <div className="button-gap">
                        <Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
                        <Button className="button" onClick={this.handleCancel} title={cancel}>{cancel}</Button>
                    </div>
                )}
            </Form>
        );
    }
}

const CreateSponsorConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        sponsorsState: state.sponsors
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        sponsorsDispatch: bindActionCreators(Sponsors.actionCreators, dispatch)
    })
)(CreateSponsorInternal));

export default class CreateSponsor extends React.Component {
    render() {
        var create = true;
        var editing = true;
        var sponsorId = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            create = utility.propCheck(propsState.create, create);
            editing = utility.propCheck(propsState.editing, editing);
            sponsorId = utility.propCheck(propsState.sponsorId, sponsorId);
        }

        return (
            <ErrorBoundary>
                <CreateSponsorConnect create={create} editing={editing} sponsorId={sponsorId} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateSponsor.js